export const SET_FILTERS = 'SET_FILTERS';

// Filter management
function BuildFiltersInstance() {
  let filters = { question: [], exam: [] };

  const labelTypes = {
    topic: 'Matéria/Assunto',
    jury: 'Banca',
    area: 'Área',
    institution: 'Orgão/Instituição',
    year: 'Ano',
    specific_training: 'Formação específica',
    difficulty_level: 'Área de formação',
    scholarity: 'Escolaridade',
    role: 'Cargo',
    location: 'Região',
    author: 'Autor',
    solution: 'Solução',
    status_owner: 'Responsável',
  };

  const entityTypes = {
    Banca: 'jury',
    Área: 'area',
    Ano: 'year',
    Escolaridade: 'scholarity',
    Cargo: 'role',
    Região: 'location',
    Autor: 'author',
    Solução: 'solution',
    'Matéria/Assunto': 'topic',
    'Orgão/Instituição': 'institution',
    'Formação específica': 'specific_training',
    'Área de formação': 'difficulty_level',
    Responsável: 'status_owner',
  };

  const create = (options) => {
    const {
      section,
      refs,
      entity,
      isAddFilter = true, // there's not exclusion filters here yet
    } = options;
    const strategies = {
      question: () => {
        filters[section].push({ add: isAddFilter, entity, refs });
      },
      exam: () => {
        filters[section].push(options);
      },
    };

    return strategies[section] && strategies[section]();
  };

  const remove = ({
    value, label, entity, section,
  }) => {
    const strategies = {
      question: () => {
        filters[section] = filters[section]
          .map((s) => {
            const filter = { ...s };

            if (filter.entity === entity) {
              filter.refs = filter.refs.filter((ref) => ref.label !== value);
              if (!filter.refs.length) {
                return null;
              }
              return filter;
            }
            return filter;
          })
          .filter(v => !!v);
      },
      exam: () => {
        filters[section] = filters[section]
          .map((s) => {
            const filter = { ...s };
            if (filter.label === label) {
              filter.filters = filter.filters.filter(item => item.value.getValue().fullName !== value);
              if (!filter.filters.length) {
                filter.filters = [];
              }
            }
            return filter;
          });
      },
    };

    return strategies[section] && strategies[section]();
  };

  const reset = () => {
    filters = { question: [], exam: [] };
  };

  const getLabel = (entity) => labelTypes[entity] || 'Label not found';
  const getEntity = (label) => entityTypes[label] || 'Label not found';

  return {
    reset,
    create,
    remove,
    getLabel,
    getEntity,
    get list() {
      return filters;
    },
  };
}

const filterHandler = BuildFiltersInstance();

export default {
  namespaced: true,
  state: {
    filters: filterHandler.list,
  },
  getters: {
    filtersLabeledDeprecated(state) {
      const labeled = state.filters.exam
        .map((section) => {
          const { label, filters } = section;
          if (!filters.length) return null;

          let fullLabel = `${label}:`;
          // Inside filters
          filters.forEach((filter) => {
            if (!filter) return null;
            const value = filter.value.getValue();
            if (value) {
              const hasMoreThan1 = filters.length > 1;
              fullLabel += `${value.fullName || value.dbValue}${hasMoreThan1 ? '|' : ''}`;
            }
          });
          return fullLabel;
        })
        .filter(value => !!value);

      return labeled;
    },
    // View ready filters
    filtersLabeled(state) {
      const sections = ['question'];

      return sections.reduce((acc, section) => {
        const labeled = state.filters[section].map((filter) => {
          const label = filterHandler.getLabel(filter.entity);
          const labels = filter.refs.map(ref => ref.label);
          return `${label}:${labels.join('|')}`;
        });

        return [
          ...acc,
          ...labeled,
        ];
      }, []);
    },
    // API ready filters
    filtersModeled(state) {
      return section => {
        const modeled = state.filters[section].map((filter) => {
          const refs = filter.refs.map(ref => String(ref.value));
          return {
            ...filter,
            refs,
          };
        });
        return modeled;
      };
    },
  },
  actions: {
    setFilters({ commit }, { section, filters }) {
      filterHandler.reset();

      filters.forEach(filter => {
        filterHandler.create({ section, ...filter });
      });

      commit(SET_FILTERS, filterHandler.list);
    },
    deleteFilter({ commit }, { section, label, value }) {
      const entity = filterHandler.getEntity(label);
      filterHandler.remove({
        value, entity, section, label,
      });
      commit(SET_FILTERS, filterHandler.list);
    },
    cleanFilters({ commit }) {
      filterHandler.reset();
      commit(SET_FILTERS, filterHandler.list);
    },
  },
  mutations: {
    [SET_FILTERS](state, filters) {
      state.filters = filters;
    },
  },
};
